import {DomainEvent} from './DomainEvent';
import {Profile} from '../resources/Profile';

export class ProfileImageUpdated extends DomainEvent<Profile> {}
